import { useSelector } from "react-redux";
import { selectStudent } from "../../reduxSlices/studentSlice";
import "./BlockedScreen.css";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import Translatable from "../Translatable/Translatable";

export default function BlockedScreen() {
  const student = useSelector(selectStudent);

  // Evita mostrar el mensaje por defecto si el estado de bloqueo ya se limpió (p.ej. durante logout).
  if (!student.bloqueoActivo) {
    return null;
  }

  return (
    <div className="blocked-screen-container">
      <div className="blocked-alert-box flex-col md:flex-row">
        <SlIcon className="blocked-alert-icon" name="exclamation-octagon"></SlIcon>
        <div className="">
          <h2>
            <Translatable as="span" capitalize>El acceso a la plataforma se encuentra bloqueado.</Translatable>
          </h2>
          <p>
            <Translatable as="span">
              {student.bloqueoMensaje ? student.bloqueoMensaje : "Consulte con el departamente de Alumnos su situación."}
            </Translatable>
          </p>
          {student.bloqueoSubmensaje && (
            <div className="blocked-contactos">
              <p>
                <Translatable as="span">{student.bloqueoSubmensaje}</Translatable>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
